import { RichTextBlock } from "@components/rich-text-block"
import { Container } from "@components/ui/Container"
import { CbRichContent as CbRichContentModel } from "__generated__/sanity"
import { FC } from "react"

type ContentPageContentBlocksCBRichContentProps = CbRichContentModel

export const ContentPageContentBlocksCBRichContent: FC<
  ContentPageContentBlocksCBRichContentProps
> = ({ contentText }) => {
  return (
    <Container>
      <RichTextBlock content={contentText} variant="regular" />
    </Container>
  )
}
